module.exports = __webpack_public_path__ + "static/media/microphone-slash.25b91d03.svg";